import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-grid-truncate-tooltip-cell',
    template: `@if (params.value) {
  <span tooltip [tooltipTitle]="params.value"
  [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'>{{params.value}}</span>
}
@if (!params.value && params.placeholder) {
  <span>{{params.placeholder}}</span>
}`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TruncateTooltipCellComponent implements AgRendererComponent {    
    params: any;

    constructor() {}

    agInit(params: any) {
        this.params = params;
    }

    refresh(): boolean {
        return false;
    }
}
